
import { TruckCategories } from '../../../util/Enum';
export default {
  data() {
    return {
      TruckCategories,
      selectedCategories: []
    };
  },
  methods: {
    handleChange () {
      this.$emit('value-changed', this.selectedCategories)
    },
    getFormattedName(name){
      if(name.length > 13) {
         return name.slice(0,12)+ '...';
      }
      return name;
   }
  }
}
